import { render } from "./SysHome.vue?vue&type=template&id=c90dc0c2"
import script from "./SysHome.vue?vue&type=script&lang=js"
export * from "./SysHome.vue?vue&type=script&lang=js"

import "./SysHome.vue?vue&type=style&index=0&id=c90dc0c2&lang=css"

import exportComponent from "F:\\物流项目\\新版项目物流项目\\delivery\\Source\\Delivery.Admin.UI\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__